import { render, staticRenderFns } from "./PcWarningIcon.vue?vue&type=template&id=a06497c6&scoped=true"
import script from "./PcWarningIcon.vue?vue&type=script&lang=js"
export * from "./PcWarningIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06497c6",
  null
  
)

export default component.exports